import parsePhoneNumberFromString from "libphonenumber-js";

export const getNumberAndDDI = (phone: string) => {
    const pn = parsePhoneNumberFromString(phone || "");
    const ddi = `+${pn?.countryCallingCode || ""}`;
    const national = pn?.formatNational() || "";

    return { ddi: ddi || "", national: national || "" };
};